import type { App } from 'vue';
import PrimeVue from 'primevue/config';
import { BsThemePreset } from './themePreset';

export function configurePrimeVue(app: App) {
    app.use(PrimeVue, {
        theme: {
            preset: BsThemePreset,
            options: {
                cssLayer: {
                    name: 'primevue',
                    order: 'base, primevue, utilities'
                },
                darkModeSelector: '.bs-dark'
            }
        }
    });
}